<nb-card [nbSpinner]="loading" nbSpinnerStatus="primary" class="card-box">
    <nb-card-header class="content-header">
        <nb-icon class="icon" icon="email-outline" status="basic"></nb-icon>
        <span class="header">{{'common.report-problem' | translate}}</span>
        <nb-icon icon="question-mark-circle-outline" nbTooltipStatus="control"
                 class="me-2 cursor-help" nbTooltip="{{'tooltips.report-problem' | translate}}"
                 nbTooltipPlacement="left"></nb-icon>
        <nb-icon class="close" icon="close-outline" (click)="cancel()"></nb-icon>
    </nb-card-header>

    <nb-card-body *ngIf="formReportProblem.errors?.['error']" class="content-body__error">
        <div class="icon">
            <nb-icon icon="alert-circle-outline" status="danger"></nb-icon>
        </div>
        <div class="text">
            {{formReportProblem.errors?.['error'] | translate}}
        </div>
    </nb-card-body>

    <nb-card-body class="content-body">
        <form [formGroup]="formReportProblem" enctype="multipart/form-data">
            <label for="subject">{{'common.subject' | translate}}:</label>
            <input nbInput
                   fullWidth
                   type="text"
                   id="subject"
                   name="subject"
                   formControlName="subject"
                   required
                   [fieldSize]="'large'"
                   [status]="hasError('subject') ? 'danger':'primary'" />
            <app-control-messages [control]="getFormControl('subject')"></app-control-messages>

            <label for="message">{{'device.details.description' | translate}}:</label>
            <textarea nbInput
                      fullWidth
                      type="text"
                      id="message"
                      name="message"
                      formControlName="message"
                      [fieldSize]="'large'"
                      [status]="hasError('message') ? 'danger':'primary'">
            </textarea>
            <app-control-messages [control]="getFormControl('message')"></app-control-messages>

            <label for="attachment">{{'common.attachment' | translate}}:</label>
            <div class="dropzone-box dropzone" id="dropFileForm" (dragover)="overrideDefault($event)"
                 (dragenter)="overrideDefault($event)" (dragleave)="overrideDefault($event);"
                 (drop)="overrideDefault($event);uploadFile($event);">
                <input type="file" hidden name="files[]" #fileInput id="fileInput" (change)="uploadFile($event)"
                       [attr.accept]="extensions" multiple>
                <div class="dropzone-box__content">
                    <div class="dropzone-box__content__image">
                        <img class="image" src="assets/draganddrop.png" alt="drag and drop" />
                    </div>
                    <div class="dropzone-box__content__text">
                        {{'device.files.drag-and-drop-file-here' | translate}}
                    </div>
                </div>
                <div class="dropzone-box__button-browse">
                    <input type="button" nbButton [status]="'control'" [size]="'large'" [appearance]="'outline'"
                           class="appearance-outline" value="{{'device.files.browse' | translate}}" (click)="fileInput.click()"
                           [attr.accept]="extensions" />
                </div>
            </div>
            <ul class="dropped-files">
                <li *ngFor="let file of droppedFiles">
                    {{file.name}}
                </li>
            </ul>
        </form>
    </nb-card-body>

    <nb-card-footer class="content-footer">
        <button nbButton [status]="'primary'" [size]="'large'"
                tabindex="-1" (click)="reportProblem()" [disabled]="formReportProblem.invalid">
            {{'common.report' | translate}}
        </button>
        <button nbButton [size]="'large'" [status]="'control'" [appearance]="'outline'"
                (click)="cancel()" tabindex="-1">
            {{'common.cancel' | translate}}
        </button>
    </nb-card-footer>
</nb-card>